// import 'whatwg-fetch' // is this used?
import actions from './actions'
import * as constants from './constants'
import * as components from './components'
import * as hooks from './hooks'
import init from './init'
import middleware from './middleware'
import reducer from './reducer'
import * as selectors from './selectors'

const { clientFactory, createClient } = selectors

export {
  actions,
  constants,
  components,
  hooks,
  init,
  middleware,
  reducer,
  selectors,
  // FIXME: temporary, just to ease migration
  clientFactory,
  createClient
}
